import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { createColumnHelper } from "@tanstack/react-table";

import { useFilters } from "../../../hooks/useFilters";
import Pagination from "../../../components/Pagination";
import Table from "../../../components/Table";
import { useAppState } from "../../../contexts/AppContext";
import { Passenger } from "../../../services/queries/passengers/types";
import Button from "../../../components/Button";
import {
  passengersResourcePath,
  useGetPassengers,
} from "../../../services/queries/passengers";
import { formatDate } from "../../../utils";
import Drawer from "../../../components/Drawer";
import UploadPassengerForm from "../../../components/forms/UploadPassengerForm";
import { requireRouteAccess } from "../../../utils/authorization";

const columnHelper = createColumnHelper<Passenger & { actions: "actions" }>();

const columns = [
  columnHelper.accessor("firstName", {
    cell: (info) => info.getValue(),
    header: "First Name",
  }),
  columnHelper.accessor("lastName", {
    cell: (info) => info.getValue(),
    header: "Last Name",
  }),
  columnHelper.accessor("email", {
    cell: (info) => info.getValue(),
    header: "Email",
  }),
  columnHelper.accessor("phone", {
    cell: (info) => info.getValue(),
    header: "Phone",
  }),
  columnHelper.accessor("created", {
    cell: (info) => formatDate(info.getValue()),
    header: "Created",
  }),
  columnHelper.accessor("actions", {
    cell: () => {
      // const { id } = row.original;

      return (
        <div className="flex gap-4">
          {/* <Button>
            Create Wallet
          </Button> */}
        </div>
      );
    },
    header: "",
  }),
];

export const Route = createFileRoute("/_app/passengers/")({
  beforeLoad: () => requireRouteAccess("/passengers"),
  component: Passengers,
});

function Passengers() {
  const {
    state: { business },
  } = useAppState();
  const businessId = business?.id || "";

  const {
    filters: { pageNumber, pageSize },
    setFilters,
    buildApiUrl,
  } = useFilters();
  const url = buildApiUrl(passengersResourcePath);

  const handlePageChange = (selectedItem: { selected: number }) => {
    setFilters({ pageNumber: selectedItem.selected + 1 });
  };

  const { isLoading, data: passengersData } = useGetPassengers(businessId, url);

  const passengers = passengersData?.data?.list || [];
  const totalRecords = passengersData?.data?.meta?.total || 0;
  const pageCount = Math.ceil(totalRecords / Number(pageSize));

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div className="flex flex-col space-y-6">
      <div className="flex items-center justify-end">
        <Button variant="primary" onClick={() => setIsDrawerOpen(true)}>
          Upload Passengers
        </Button>
      </div>

      <div className="bg-white overflow-x-auto relative p-6">
        <Table
          loading={isLoading}
          data={passengers}
          columns={columns}
          rowClassName="uppercase"
        />

        <Pagination
          pageCount={pageCount}
          currentPage={pageNumber}
          onPageChange={handlePageChange}
        />
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Upload Passengers"
      >
        <UploadPassengerForm
          businessId={businessId}
          onClose={() => setIsDrawerOpen(false)}
        />
      </Drawer>
    </div>
  );
}
